// ISO 3166-1 alpha-2 country list with Italian names
// Common emergency/migration source countries listed first for usability
export const COUNTRIES = [
  // Frequent (top of list)
  { code: 'IT', name: 'Italia', flag: '🇮🇹' },
  { code: 'SM', name: 'San Marino', flag: '🇸🇲' },
  { code: 'VA', name: 'Città del Vaticano', flag: '🇻🇦' },
  { code: 'UA', name: 'Ucraina', flag: '🇺🇦' },
  { code: 'SY', name: 'Siria', flag: '🇸🇾' },
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫' },
  { code: 'PS', name: 'Palestina', flag: '🇵🇸' },
  { code: 'SD', name: 'Sudan', flag: '🇸🇩' },
  { code: 'SO', name: 'Somalia', flag: '🇸🇴' },
  { code: 'ER', name: 'Eritrea', flag: '🇪🇷' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
  { code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
  { code: 'MA', name: 'Marocco', flag: '🇲🇦' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿' },
  { code: 'EG', name: 'Egitto', flag: '🇪🇬' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱' },
  { code: 'RO', name: 'Romania', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
  { code: 'PL', name: 'Polonia', flag: '🇵🇱' },
  { code: 'MD', name: 'Moldova', flag: '🇲🇩' },
  { code: 'TR', name: 'Turchia', flag: '🇹🇷' },
  { code: 'IR', name: 'Iran', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', flag: '🇮🇶' },
  { code: 'YE', name: 'Yemen', flag: '🇾🇪' },
  { code: 'LY', name: 'Libia', flag: '🇱🇾' },
  // Rest alphabetical
  { code: 'AD', name: 'Andorra', flag: '🇦🇩' },
  { code: 'AE', name: 'Emirati Arabi Uniti', flag: '🇦🇪' },
  { code: 'AG', name: 'Antigua e Barbuda', flag: '🇦🇬' },
  { code: 'AM', name: 'Armenia', flag: '🇦🇲' },
  { code: 'AO', name: 'Angola', flag: '🇦🇴' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺' },
  { code: 'AZ', name: 'Azerbaigian', flag: '🇦🇿' },
  { code: 'BA', name: 'Bosnia ed Erzegovina', flag: '🇧🇦' },
  { code: 'BB', name: 'Barbados', flag: '🇧🇧' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩' },
  { code: 'BE', name: 'Belgio', flag: '🇧🇪' },
  { code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'BH', name: 'Bahrain', flag: '🇧🇭' },
  { code: 'BI', name: 'Burundi', flag: '🇧🇮' },
  { code: 'BJ', name: 'Benin', flag: '🇧🇯' },
  { code: 'BN', name: 'Brunei', flag: '🇧🇳' },
  { code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
  { code: 'BR', name: 'Brasile', flag: '🇧🇷' },
  { code: 'BS', name: 'Bahamas', flag: '🇧🇸' },
  { code: 'BT', name: 'Bhutan', flag: '🇧🇹' },
  { code: 'BW', name: 'Botswana', flag: '🇧🇼' },
  { code: 'BY', name: 'Bielorussia', flag: '🇧🇾' },
  { code: 'BZ', name: 'Belize', flag: '🇧🇿' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦' },
  { code: 'CD', name: 'Repubblica Democratica del Congo', flag: '🇨🇩' },
  { code: 'CF', name: 'Repubblica Centrafricana', flag: '🇨🇫' },
  { code: 'CG', name: 'Repubblica del Congo', flag: '🇨🇬' },
  { code: 'CH', name: 'Svizzera', flag: '🇨🇭' },
  { code: 'CI', name: "Costa d'Avorio", flag: '🇨🇮' },
  { code: 'CL', name: 'Cile', flag: '🇨🇱' },
  { code: 'CM', name: 'Camerun', flag: '🇨🇲' },
  { code: 'CN', name: 'Cina', flag: '🇨🇳' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
  { code: 'CU', name: 'Cuba', flag: '🇨🇺' },
  { code: 'CV', name: 'Capo Verde', flag: '🇨🇻' },
  { code: 'CY', name: 'Cipro', flag: '🇨🇾' },
  { code: 'CZ', name: 'Repubblica Ceca', flag: '🇨🇿' },
  { code: 'DE', name: 'Germania', flag: '🇩🇪' },
  { code: 'DJ', name: 'Gibuti', flag: '🇩🇯' },
  { code: 'DK', name: 'Danimarca', flag: '🇩🇰' },
  { code: 'DM', name: 'Dominica', flag: '🇩🇲' },
  { code: 'DO', name: 'Repubblica Dominicana', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
  { code: 'EE', name: 'Estonia', flag: '🇪🇪' },
  { code: 'ES', name: 'Spagna', flag: '🇪🇸' },
  { code: 'ET', name: 'Etiopia', flag: '🇪🇹' },
  { code: 'FI', name: 'Finlandia', flag: '🇫🇮' },
  { code: 'FJ', name: 'Figi', flag: '🇫🇯' },
  { code: 'FR', name: 'Francia', flag: '🇫🇷' },
  { code: 'GA', name: 'Gabon', flag: '🇬🇦' },
  { code: 'GB', name: 'Regno Unito', flag: '🇬🇧' },
  { code: 'GD', name: 'Grenada', flag: '🇬🇩' },
  { code: 'GE', name: 'Georgia', flag: '🇬🇪' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭' },
  { code: 'GM', name: 'Gambia', flag: '🇬🇲' },
  { code: 'GN', name: 'Guinea', flag: '🇬🇳' },
  { code: 'GQ', name: 'Guinea Equatoriale', flag: '🇬🇶' },
  { code: 'GR', name: 'Grecia', flag: '🇬🇷' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
  { code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', flag: '🇬🇾' },
  { code: 'HN', name: 'Honduras', flag: '🇭🇳' },
  { code: 'HR', name: 'Croazia', flag: '🇭🇷' },
  { code: 'HT', name: 'Haiti', flag: '🇭🇹' },
  { code: 'HU', name: 'Ungheria', flag: '🇭🇺' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'IE', name: 'Irlanda', flag: '🇮🇪' },
  { code: 'IL', name: 'Israele', flag: '🇮🇱' },
  { code: 'IN', name: 'India', flag: '🇮🇳' },
  { code: 'IS', name: 'Islanda', flag: '🇮🇸' },
  { code: 'JM', name: 'Giamaica', flag: '🇯🇲' },
  { code: 'JO', name: 'Giordania', flag: '🇯🇴' },
  { code: 'JP', name: 'Giappone', flag: '🇯🇵' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪' },
  { code: 'KG', name: 'Kirghizistan', flag: '🇰🇬' },
  { code: 'KH', name: 'Cambogia', flag: '🇰🇭' },
  { code: 'KI', name: 'Kiribati', flag: '🇰🇮' },
  { code: 'KM', name: 'Comore', flag: '🇰🇲' },
  { code: 'KN', name: 'Saint Kitts e Nevis', flag: '🇰🇳' },
  { code: 'KP', name: 'Corea del Nord', flag: '🇰🇵' },
  { code: 'KR', name: 'Corea del Sud', flag: '🇰🇷' },
  { code: 'KW', name: 'Kuwait', flag: '🇰🇼' },
  { code: 'KZ', name: 'Kazakistan', flag: '🇰🇿' },
  { code: 'LA', name: 'Laos', flag: '🇱🇦' },
  { code: 'LB', name: 'Libano', flag: '🇱🇧' },
  { code: 'LC', name: 'Santa Lucia', flag: '🇱🇨' },
  { code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: 'LR', name: 'Liberia', flag: '🇱🇷' },
  { code: 'LS', name: 'Lesotho', flag: '🇱🇸' },
  { code: 'LT', name: 'Lituania', flag: '🇱🇹' },
  { code: 'LU', name: 'Lussemburgo', flag: '🇱🇺' },
  { code: 'LV', name: 'Lettonia', flag: '🇱🇻' },
  { code: 'MC', name: 'Monaco', flag: '🇲🇨' },
  { code: 'ME', name: 'Montenegro', flag: '🇲🇪' },
  { code: 'MG', name: 'Madagascar', flag: '🇲🇬' },
  { code: 'MH', name: 'Isole Marshall', flag: '🇲🇭' },
  { code: 'MK', name: 'Macedonia del Nord', flag: '🇲🇰' },
  { code: 'ML', name: 'Mali', flag: '🇲🇱' },
  { code: 'MM', name: 'Myanmar', flag: '🇲🇲' },
  { code: 'MN', name: 'Mongolia', flag: '🇲🇳' },
  { code: 'MR', name: 'Mauritania', flag: '🇲🇷' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹' },
  { code: 'MU', name: 'Mauritius', flag: '🇲🇺' },
  { code: 'MV', name: 'Maldive', flag: '🇲🇻' },
  { code: 'MW', name: 'Malawi', flag: '🇲🇼' },
  { code: 'MX', name: 'Messico', flag: '🇲🇽' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
  { code: 'MZ', name: 'Mozambico', flag: '🇲🇿' },
  { code: 'NA', name: 'Namibia', flag: '🇳🇦' },
  { code: 'NE', name: 'Niger', flag: '🇳🇪' },
  { code: 'NI', name: 'Nicaragua', flag: '🇳🇮' },
  { code: 'NL', name: 'Paesi Bassi', flag: '🇳🇱' },
  { code: 'NO', name: 'Norvegia', flag: '🇳🇴' },
  { code: 'NP', name: 'Nepal', flag: '🇳🇵' },
  { code: 'NR', name: 'Nauru', flag: '🇳🇷' },
  { code: 'NZ', name: 'Nuova Zelanda', flag: '🇳🇿' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲' },
  { code: 'PA', name: 'Panama', flag: '🇵🇦' },
  { code: 'PE', name: 'Perù', flag: '🇵🇪' },
  { code: 'PG', name: 'Papua Nuova Guinea', flag: '🇵🇬' },
  { code: 'PH', name: 'Filippine', flag: '🇵🇭' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰' },
  { code: 'PT', name: 'Portogallo', flag: '🇵🇹' },
  { code: 'PW', name: 'Palau', flag: '🇵🇼' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦' },
  { code: 'RS', name: 'Serbia', flag: '🇷🇸' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺' },
  { code: 'RW', name: 'Ruanda', flag: '🇷🇼' },
  { code: 'SA', name: 'Arabia Saudita', flag: '🇸🇦' },
  { code: 'SB', name: 'Isole Salomone', flag: '🇸🇧' },
  { code: 'SC', name: 'Seychelles', flag: '🇸🇨' },
  { code: 'SE', name: 'Svezia', flag: '🇸🇪' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬' },
  { code: 'SI', name: 'Slovenia', flag: '🇸🇮' },
  { code: 'SK', name: 'Slovacchia', flag: '🇸🇰' },
  { code: 'SL', name: 'Sierra Leone', flag: '🇸🇱' },
  { code: 'SN', name: 'Senegal', flag: '🇸🇳' },
  { code: 'SR', name: 'Suriname', flag: '🇸🇷' },
  { code: 'SS', name: 'Sud Sudan', flag: '🇸🇸' },
  { code: 'ST', name: 'São Tomé e Príncipe', flag: '🇸🇹' },
  { code: 'SV', name: 'El Salvador', flag: '🇸🇻' },
  { code: 'SZ', name: 'Eswatini', flag: '🇸🇿' },
  { code: 'TD', name: 'Ciad', flag: '🇹🇩' },
  { code: 'TG', name: 'Togo', flag: '🇹🇬' },
  { code: 'TH', name: 'Thailandia', flag: '🇹🇭' },
  { code: 'TJ', name: 'Tagikistan', flag: '🇹🇯' },
  { code: 'TL', name: 'Timor Est', flag: '🇹🇱' },
  { code: 'TM', name: 'Turkmenistan', flag: '🇹🇲' },
  { code: 'TO', name: 'Tonga', flag: '🇹🇴' },
  { code: 'TT', name: 'Trinidad e Tobago', flag: '🇹🇹' },
  { code: 'TV', name: 'Tuvalu', flag: '🇹🇻' },
  { code: 'TW', name: 'Taiwan', flag: '🇹🇼' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿' },
  { code: 'UG', name: 'Uganda', flag: '🇺🇬' },
  { code: 'US', name: 'Stati Uniti', flag: '🇺🇸' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿' },
  { code: 'VC', name: 'Saint Vincent e Grenadine', flag: '🇻🇨' },
  { code: 'VE', name: 'Venezuela', flag: '🇻🇪' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
  { code: 'VU', name: 'Vanuatu', flag: '🇻🇺' },
  { code: 'WS', name: 'Samoa', flag: '🇼🇸' },
  { code: 'XK', name: 'Kosovo', flag: '🇽🇰' },
  { code: 'ZA', name: 'Sudafrica', flag: '🇿🇦' },
  { code: 'ZM', name: 'Zambia', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼' },
];

export function getCountryByCode(code) {
  return COUNTRIES.find(c => c.code === code);
}
